import { useState, useMemo } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Loading } from '../Shared/Loading';
import { GroupMembersTable } from './GroupMembersTable';
import { Search } from '../Shared/Search';
import { PermissionGroupMember } from '../../api/models';

export interface GroupMembersEnhancedTableProps {
    data: PermissionGroupMember[];
    isLoading: boolean;
}

export function GroupMembersEnhancedTable({ data, isLoading }: GroupMembersEnhancedTableProps) {
    const [searchTerm, setSearchTerm] = useState('');

    const searchedData = useMemo(() => {
        const searchString = searchTerm.trim().toLowerCase();

        if (searchString.length === 0) {
            return data;
        }

        return data.filter((groupmember: PermissionGroupMember) => {
            return groupmember.displayName.toLowerCase().includes(searchString);
        });
    }, [searchTerm, data]);

    if (isLoading) {
        return <Loading />;
    }

    return (
        <div>
            <Row>
                <Col>{<Search onUpdate={setSearchTerm} />}</Col>
            </Row>
            {<GroupMembersTable data={searchedData} />}
        </div>
    );
}
